import { Alert, Button, Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { LoginCredentials } from "../services/models/credentials";
import styleUtils from "../assets/styles/utils.module.css";
import stylesButtons from "../assets/styles/buttons.module.css";
import styles from "../assets/styles/AuthPage.module.css";
import stylesInputs from "../assets/styles/inputs.module.css";
import TextInputField from "./AdminComponents/form/TextInputField";

interface LoginModalProps {
    errorText?: string | null,
    onSubmit: (credentials: LoginCredentials) => void,
}

const LoginModal = ({errorText, onSubmit}: LoginModalProps) => {
    const {register, handleSubmit, formState: {errors, isSubmitting, isValid, isDirty}} = useForm<LoginCredentials>({
        mode: "onChange"
    });

    return (
        <>
            <Container className={styleUtils.flexBlockCenter}>
                {errorText &&
                    <Alert variant="danger">
                        {errorText}
                    </Alert>
                }
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <TextInputField 
                        name="login"
                        label="Введите логин"
                        type="text"
                        placeholder="Логин"
                        register={register}
                        registerOptions={{required: "Обязательное поле"}}
                        error={errors.login}
                        className={`${styles.inputField} ${stylesInputs.mainInput}`}
                    />
                    <TextInputField 
                        name="password"
                        label="Введите пароль"
                        type="password"
                        placeholder="Пароль"
                        register={register}
                        registerOptions={{required: "Обязательное поле"}}
                        error={errors.password}
                        className={`${styles.inputField} ${stylesInputs.mainInput}`}
                        typeFunctionality={"clear"}
                    />
                    <Button
                        type="submit"
                        disabled={!isDirty || !isValid}
                        className={`${styleUtils.flexSizeButton} ${stylesButtons.authButton}`}
                    >
                        Войти
                    </Button>
                </Form>
            </Container>
        </>
    );
}

export default LoginModal;